import React, { useRef } from 'react'
import TestimonyBubbleChat from './TestimonyBubbleChat'
import TitleTemp from '../TitleTemp';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';

const TestimonyCarousel = ({ year }: { year: number }) => {
  const scrollRef = useRef<HTMLDivElement>(null);

  const scroll = (direction: string) => {
    const container = scrollRef.current;
    if (!container) return;

    const scrollAmount = 400;
    container.scrollBy({ 
      left: direction === 'left' ? -scrollAmount : scrollAmount, 
      behavior: 'smooth' 
    });
  };

  // 🔥 Store testimonies by year
  const testimoniesByYear: Record<number, string[]> = {
    2024: [
      "Lombanya seru banget, apalagi pas robot kami berhasil lewati rintangan!",
      "Aku senang bisa nunjukin ide inovatif kami ke para juri dan teman-teman lain.",
      "Rasanya deg-degan tapi bangga waktu coding-ku bisa jalan dengan benar.",
      "Seru banget, aku bisa belajar hal baru dan lihat proyek keren dari peserta lain.",
      "Tim kami kerja keras semalaman, dan semua terbayar pas diumumkan jadi juara!",
      "Bikin robot bareng teman itu asik, kita jadi makin kompak!",
      "Seneng bisa ikut lomba nasional, nambah teman dan pengalaman juga!",
      "Aku jadi pengen masuk jurusan teknologi gara-gara ikut IIT Challenge ini.",
      "Paling seru pas sesi presentasi, kami dapet feedback bagus dari juri!",
      "Belajar dari tim lain juga jadi pengalaman berharga buat kami.",
      "Venue-nya keren, suasananya semangat banget!",
      "Pertama kali ikut lomba coding dan langsung dapat pengalaman luar biasa!",
      "Robot kami sempat error, tapi seru waktu perbaikannya bareng tim.",
      "Challenge-nya bikin mikir dan jadi lebih kreatif nyari solusi.",
      "Seneng bisa pakai Python beneran buat ngerjain soal real-world.",
      "Banyak banget hal baru yang aku pelajari di event ini!",
      "Aku suka pas demo robot, semua tim saling kasih semangat.",
      "Dapet relasi dari berbagai kota, seru bisa tukar cerita!",
      "Juri-jurinya ramah tapi tetap objektif dan profesional.",
      "Aku jadi makin semangat belajar teknologi dan robotika!",
      "Kita bangga bisa wakilin sekolah di event sebesar ini.",
      "Ini event lomba paling berkesan sepanjang aku sekolah!",
      "Seru karena semua orang passionate dan open untuk belajar.",
      "Lomba ini ngelatih aku untuk berpikir cepat dan kerja tim.",
      "Presentasi symposium bikin aku lebih pede ngomong di depan umum.",
      "Ide-ide dari peserta lain bikin aku makin termotivasi!",
      "Kami gak nyangka bisa tembus final, rasanya luar biasa!",
      "Waktu pengumuman pemenang, semuanya tegang dan antusias!",
      "Aku suka bagian workshop-nya, bener-bener nambah skill!",
      "Semoga tahun depan aku bisa ikut lagi dan bawa tim baru!"
    ],
    // 2026: [
    //   "2025 testimonies coming soon!",
    //   "Stay tuned!",
    // ],
  };

  const testimonies = testimoniesByYear[year] ?? [];

  const colors = ["#fb923c", "#34d399", "#f87171", "#a78bfa", "#22d3ee"];

  return (
    <div>
      <TitleTemp color='text-white' name={`Testimonies ${year}`} />

      {testimonies.length === 0 ? (
          <h1 className="text-center text-gray-400 font-bold">
            <span className="block text-xl md:text-3xl py-1">
              Coming Soon
            </span>

            <span className="block text-sm md:text-xl font-medium opacity-90">
              Voices that matter, real experiences, coming your way
            </span>
          </h1>
      ) : (
        <div className='relative flex items-center px-5 -mt-3 -mb-16'>
          <div ref={scrollRef} className="overflow-x-auto p-4 grid grid-flow-col auto-rows-max grid-rows-2 gap-x-8 gap-y-4 hide-scrollbar">
            {testimonies.map((text, index) => {
              const randomColor = colors[Math.floor(Math.random() * colors.length)];
              return (
                <TestimonyBubbleChat key={index} text={text} color={randomColor} />
              );
            })}
          </div>

          <button 
            onClick={() => scroll('left')} 
            className='absolute left-0 w-10 h-10 flex items-center justify-center rounded-full bg-defaultBlue text-white'>
            <FontAwesomeIcon icon={faChevronLeft} />
          </button>

          <button 
            onClick={() => scroll('right')} 
            className='absolute right-0 w-10 h-10 flex items-center justify-center rounded-full bg-defaultBlue text-white'>
            <FontAwesomeIcon icon={faChevronRight} />
          </button>
        </div>
      )}
    </div>
  );
};

export default TestimonyCarousel;